<script setup lang="ts">
import FilterTag from '#components/tag/filterTag/FilterTag.vue';
import { useKpisPerimeter } from '#composables/kpisPerimeter';
import { useLanguage } from '#composables/useLanguage';
import FiltersActiveTags from '#domain/core/filter/components/FiltersActiveTags.vue';
import { formatCustomDateToLocaleFR } from '#i18n';
import {
  formatNielsenPeriodToReadableStr,
  nielsenPeriodStrToNielsenPeriod,
  type PerimeterFilterViewType,
  type ProductFilterScopeType
} from '@carrefour-gcs/shared';
import { computed } from 'vue';

const props = defineProps<{ perimeterFilterView?: PerimeterFilterViewType }>();

const { t } = useLanguage();
const {
  taxonomy: { taxonomy },
  withTax: { isWithTax },
  period: { selectedPeriod },
  productFilterConfig
} = useKpisPerimeter();

const productFilterScope = computed<ProductFilterScopeType>(() =>
  props.perimeterFilterView === 'competitorVisionZoomPage' ? 'competitorBase' : 'default'
);

const intervalPeriodLabels = computed(() => {
  if (selectedPeriod.value.period === 'nielsen') {
    return {
      start: formatNielsenPeriodToReadableStr(
        nielsenPeriodStrToNielsenPeriod(selectedPeriod.value.periodInterval.start)
      ),
      end: formatNielsenPeriodToReadableStr(nielsenPeriodStrToNielsenPeriod(selectedPeriod.value.periodInterval.end))
    };
  }

  return {
    start: formatCustomDateToLocaleFR(selectedPeriod.value.periodInterval.start),
    end: formatCustomDateToLocaleFR(selectedPeriod.value.periodInterval.end)
  };
});
</script>

<template>
  <div class="flex items-center gap-2 flex-wrap">
    <FilterTag size="sm" :title="t('dataTableConfigurationPopIn.perimeter.dates')">
      {{ t('commonLabel.from') }} {{ intervalPeriodLabels.start }} {{ t('commonLabel.to') }}
      {{ intervalPeriodLabels.end }} {{ t('timeSelector.vsLastYear') }}
    </FilterTag>
    <FilterTag size="sm" :title="t('commonLabel.taxonomy')" class="capitalize">{{ taxonomy }}</FilterTag>
    <FilterTag size="sm" :title="t('commonLabel.value')">{{
      isWithTax
        ? t('performanceCarrefourCatman.salesAmountFormat.TTC')
        : t('performanceCarrefourCatman.salesAmountFormat.HT')
    }}</FilterTag>

    <FiltersActiveTags
      :product-filter-config="productFilterConfig[productFilterScope]"
      :perimeter-filter-view="perimeterFilterView"
      size="sm"
    />
  </div>
</template>
